<template>
    <v-container fluid>
        <h1 class="sub_tit">
            방문신청 정보
        </h1>

        <v-card flat color="rgba(0,0,0,0)">
            <v-card-text v-if="visitId" class="pa-2">
                <apply-view ref="applyView" :visitId="visitId" />
            </v-card-text>
            <v-card-text v-else style="font-size: 1.4rem">
                신청 내역이 없습니다.
            </v-card-text>
            <v-card-actions v-if="force" class="justify-center">
                <v-btn v-if="visitInfo && ['WAITING', 'PENDING'].includes(visitInfo.visitStatus)"
                       @click="approveConfirm"
                       color="primary"
                >
                    승인
                </v-btn>
                <v-btn v-if="visitInfo && ['WAITING', 'PENDING'].includes(visitInfo.visitStatus)"
                       @click="rejectConfirm"
                       class="ml-4"
                >
                    반려
                </v-btn>
                <v-btn v-if="visitInfo && ['APPROVED'].includes(visitInfo.visitStatus)"
                       @click="cancelConfirm"
                       class="ml-4"
                >
                    취소
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import cryptoWrapper from "@/service/cryptoWrapper";
import {mapState} from "vuex";
import ApplyActionMixin from "@/components/apply/ApplyActionMixin";

export default {
    name: 'VisitInfo',
    mixins: [ ApplyActionMixin ],
    components: {
        ApplyView: () => import("@/components/apply/ApplyView")
    },

    data: () => ({
        visitId: null,
        visitInfo: null,
        visitors: [],
        force: false,
        encryptedVisitId: null,
    }),

    computed: {
        ...mapState(['secretKey', 'iv']),
    },

    async created() {
        this.force = this.$route.params.force === 't';
        this.encryptedVisitId = this.$route.params.encryptedVisitId;
        const visitId = parseInt(cryptoWrapper.decrypt(this.encryptedVisitId, this.secretKey, this.iv));
        this.visitId = isNaN(visitId) ? null : visitId;
        await this.fetchApplyInfo(this.visitId)
    },

    methods: {
        async fetchApplyInfo(visitId) {
            this.$window.showLoading("로딩 중...");

            try {
                let { visitInfo, visitors } = await this.getApplyInfo(visitId);
                this.visitInfo = visitInfo;
                this.visitors = visitors;
            } catch(err) {
                this.$window.alert(err.message, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },

        /**
         * 방문 승인
         *
         */
        async approveConfirm() {
            const result = await this.$window.confirm('방문을 승인 하시겠습니까?');

            if (!result) {
                return;
            }

            this.$window.showLoading('승인 중...');

            try {
                await this.approve(this.visitInfo, this.visitors);
                this.$window.alert('승인 되었습니다.');
                await this.fetchApplyInfo(this.visitId);
                await this.$refs.applyView.reload();
            } catch(err) {
                this.$window.alert(err.message ? err.message : err, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },

        /**
         * 방문 반려
         *
         */
        async rejectConfirm() {
            const reason = await this.$window.prompt('반려 사유를 입력해주세요.', true, '반려 사유');
            if (!reason) {
                return;
            }

            this.$window.showLoading('반려 중...');

            try {
                await this.reject(this.visitInfo, this.visitors, reason);
                this.$window.alert('반려 되었습니다.');
                await this.fetchApplyInfo(this.visitId);
                await this.$refs.applyView.reload();
            } catch(err) {
                this.$window.alert(err.message ? err.message : err, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },

        /**
         * 방문 취소
         *
         */
        async cancelConfirm() {
            const reason = await this.$window.prompt('취소 사유를 입력해주세요.', true, '취소 사유');
            if (!reason) {
                return;
            }

            this.$window.showLoading('취소 중...');

            try {
                await this.cancel(this.visitInfo, this.visitors, reason);
                this.$window.alert('취소 되었습니다.');
                await this.fetchApplyInfo(this.visitId);
                await this.$refs.applyView.reload();
            } catch(err) {
                this.$window.alert(err.message ? err.message : err, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },
    },
}
</script>
